import React from 'react';
import { ShieldIcon, SparklesIcon, HeartPulseIcon, ShieldCheckIcon } from 'lucide-react';
export function GutHealthExplanation() {
  return <section className="py-12 sm:py-16 lg:py-20 bg-white" data-id="element-189">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-190">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-[rgb(var(--color-neutral-900))] mb-3 sm:mb-4" data-id="element-191">
          De Onzichtbare Strijd in de Darmen van uw Hond
        </h2>

        <p className="text-base sm:text-lg text-center text-[rgb(var(--color-neutral-800))] mb-12 sm:mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-192">
          In de darmen van je hond woont een complete wereld van miljarden
          bacteriën, de zogenaamde darmflora. Wanneer deze darmflora gezond en
          in balans is, werkt het als een krachtig afweerleger dat je hond
          beschermt tegen ziekten, virussen en infecties.
        </p>

        {/* Mobile: Stacked vertically (Unhealthy first, then Healthy) */}
        {/* Desktop: Side by side */}
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 sm:gap-12 mb-12 sm:mb-16" data-id="element-193">
          {/* Unhealthy Gut - Shows FIRST on mobile */}
          <div className="order-2 lg:order-2 bg-gradient-to-br from-red-50 to-orange-50 p-6 sm:p-8 rounded-2xl border-2 border-red-200" data-id="element-194">
            <h3 className="text-xl sm:text-2xl font-bold text-red-800 mb-4 sm:mb-6 flex items-center gap-3" data-id="element-195">
              <ShieldIcon className="w-6 h-6 sm:w-8 sm:h-8 text-red-600 flex-shrink-0" data-id="element-196" />
              <span data-id="element-197">Beschadigde Darmflora</span>
            </h3>

            <div className="space-y-3 sm:space-y-4" data-id="element-198">
              {['Slechte opname van voedingsstoffen', 'Verzwakt immuunsysteem', 'Verminderd zelfhelend vermogen', 'Schadelijke bacteriën krijgen vrij spel'].map((problem, index) => <div key={index} className="flex items-start gap-3 bg-white/60 p-3 sm:p-4 rounded-lg" data-id="element-199">
                  <span className="text-red-600 text-lg sm:text-xl flex-shrink-0" data-id="element-200">
                    ❌
                  </span>
                  <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))] font-medium" data-id="element-201">
                    {problem}
                  </p>
                </div>)}
            </div>

            <div className="mt-4 sm:mt-6 text-center" data-id="element-202">
              <div className="inline-flex gap-1 sm:gap-2 text-2xl sm:text-4xl flex-wrap justify-center" data-id="element-203">
                {[...Array(8)].map((_, i) => <span key={i} className={i % 3 === 0 ? '' : 'opacity-30'} data-id="element-204">
                    {i % 3 === 0 ? '😠' : '😊'}
                  </span>)}
              </div>
              <p className="text-xs sm:text-sm text-red-700 mt-2 font-semibold" data-id="element-205">
                Bacteriën uit balans
              </p>
            </div>
          </div>

          {/* Healthy Gut - Shows SECOND on mobile */}
          <div className="order-1 lg:order-1 bg-gradient-to-br from-green-50 to-emerald-50 p-6 sm:p-8 rounded-2xl border-2 border-green-200" data-id="element-206">
            <h3 className="text-xl sm:text-2xl font-bold text-green-800 mb-4 sm:mb-6 flex items-center gap-3" data-id="element-207">
              <ShieldCheckIcon className="w-6 h-6 sm:w-8 sm:h-8 flex-shrink-0" data-id="element-208" />
              <span data-id="element-209">Gezonde Darmflora</span>
            </h3>

            <div className="space-y-3 sm:space-y-4" data-id="element-210">
              {[{
              icon: <SparklesIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-211" />,
              text: 'Voedingsstoffen goed worden opgenomen'
            }, {
              icon: <ShieldIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-212" />,
              text: 'Het immuunsysteem sterk blijft'
            }, {
              icon: <HeartPulseIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-213" />,
              text: 'Het zelfhelend vermogen wordt geactiveerd'
            }, {
              icon: <ShieldCheckIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-214" />,
              text: 'Schadelijke bacteriën geen kans krijgen'
            }].map((benefit, index) => <div key={index} className="flex items-start gap-3 bg-white/60 p-3 sm:p-4 rounded-lg" data-id="element-215">
                  <div className="text-green-600 flex-shrink-0 mt-0.5 sm:mt-1" data-id="element-216">
                    {benefit.icon}
                  </div>
                  <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))] font-medium" data-id="element-217">
                    {benefit.text}
                  </p>
                </div>)}
            </div>

            <div className="mt-4 sm:mt-6 text-center" data-id="element-218">
              <div className="inline-flex gap-1 sm:gap-2 text-2xl sm:text-4xl flex-wrap justify-center" data-id="element-219">
                {[...Array(8)].map((_, i) => <span key={i} className="animate-pulse" style={{
                animationDelay: `${i * 0.1}s`
              }} data-id="element-220">
                    😊
                  </span>)}
              </div>
              <p className="text-xs sm:text-sm text-green-700 mt-2 font-semibold" data-id="element-221">
                Goede bacteriën in balans
              </p>
            </div>
          </div>
        </div>

        <div className="bg-[rgb(var(--color-neutral-900))] text-white p-6 sm:p-8 rounded-2xl text-center max-w-3xl mx-auto" data-id="element-222">
          <p className="text-lg sm:text-xl font-bold mb-2" data-id="element-223">
            Maar hier komt het probleem...
          </p>
          <p className="text-base sm:text-lg opacity-90 leading-relaxed" data-id="element-224">
            Veel factoren in het moderne leven van je hond verstoren deze
            delicate balans dagelijks.
          </p>
        </div>
      </div>
    </section>;
}